<template>
  <div class="container mescroll-touch">
    <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
    <div class="containerBox" id="toTop">
    <div class="headerBox">
      <div class="top">
        <div class="searchBox" @click="$router.push('/search')">
          <img class="searchIcon" src="@/assets/images/search_comm_icon@2x.png" />
          <span class="searchInput">请输入关键字搜索</span>
          <!-- <input class="searchInput" type="text" placeholder="请输入关键字搜索" disabled /> -->
        </div>
      </div>
      <div class="classify">
        <div class="classify_content" ref="wrapper">
          <div class="classify_wrapper">
            <span @click="toHome">
              <template v-if="userInfo.Type != 3">全部</template>
              <template v-if="userInfo.Type == 3">ALL</template>
            </span>
            <span :class="{'active_classify': departmentId == item.Id}" v-for="(item, index) in navBar" :key="index" :ref="item.Code" @click="toDepartment(item.Id, item.Code, item.TCode, item.DisplayName)">{{item.DisplayName}}</span>
          </div>
        </div>
        <div class="more">
          <router-link to="/interest">
            <img class="addIcon" src="@/assets/images/ellipsis.png" />
            <span>{{userInfo.Type != 3 ? '更多科室' : 'More'}}</span>
          </router-link>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="department_classify">
        <span :class="{'department_classify_active': operativeActiveList.indexOf(0) !== -1}" @click="selectOperative(0, code + '|', code, '全部')">ALL</span>
        <span :class="{'department_classify_active': operativeActiveList.indexOf(parseInt(item.Value)) !== -1}" v-for="(item, index) in operativeList" :key="index" @click="selectOperative(item.Value, item.TCcode, item.code, item.Name)">{{item.Name}}</span>
      </div>
      <div class="banner" v-if="bannerList.length > 0">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#CA001B">
          <van-swipe-item v-for="(item, index) in bannerList" :key="index" @click="imgclick(item)">
            <img class="bannerImg" :src="item.File_Url" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="section">
        <div class="section_box" v-for="(item, index) in columnList" :key="index">
          <div class="section_item" @click="selectColumns(item.Id, item.TCode, item.Code, item.DisplayName)">
            <img :src="ColumnId == item.Id ? item.CheckedImgUrl : item.NotCheckedImgUrl" />
            <span :class="{'section_item_active': ColumnId == item.Id}">{{item.DisplayName}}</span>
          </div>
        </div>
      </div>
      <div class="listContainer" :style="{'marginBottom': list.length > 0 ? '0px' : '20px'}">
        <div class="classify_title">
          <div class="classify_title_left">
            <div class="classify_item" :class="{'classify_title_active': ModuleType == 1}" @click="selectClassify(1)">
              <div class="classifyIcon">
                <img class="classifyIcon1" src="@/assets/images/new_icon.png" />
              </div>
              <div class="classifyTitle">
                <template v-if="userInfo.Type != 3">最新</template>
                <template v-if="userInfo.Type == 3">New</template>
              </div>
            </div>
            <div class="classify_item" :class="{'classify_title_active': ModuleType == 2}" @click="selectClassify(2)">
              <div class="classifyIcon">
                <img class="classifyIcon2" src="@/assets/images/hot_icon.png" />
              </div>
              <div class="classifyTitle">
                <template v-if="userInfo.Type != 3">最热</template>
                <template v-if="userInfo.Type == 3">Hot</template>
              </div>
            </div>
          </div>
        </div>
        <div id="dataList">
          <waterfall ref="waterfall" :col="2" :gutterWidth="10" :data="list">
            <template>
              <div class="list" v-for="(item, index) in list" :key="index" @click="toContentPage(item.Id, item.Type)">
                <div class="item_img">
                  <img class="item_cover" :src="item.Thumbnail" />
                  <img class="playIcon" v-if="item.Type == 1 || item.Type == 3" src="@/assets/images/play_icon.png" />
                </div>
                <div class="item_content">
                  <span class="item_title van-multi-ellipsis--l2">{{item.Title}}</span>
                  <div class="doctor_info" v-if="item.Speaker || item.HospitalName">
                    {{item.Speaker}} <span v-if="item.HospitalName">|</span> {{item.HospitalName}}
                  </div>
                  <!-- <div class="item_flexbox">
                    <p class="item_time">{{item.yyyymmdd}}</p>
                    <div class="item_nums">
                      <div class="nums">
                        <img src="@/assets/images/browse_comm_icon@2x.png" />
                        <span>{{item.WatchCount}}</span>
                      </div>
                      <div class="nums">
                        <img src="@/assets/images/like_comm_icon@2x.png" />
                        <span>{{item.LikeCount}}</span>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </template>
          </waterfall>
        </div>
      </div>
    </div>
    </div>
    </mescroll-vue>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import { mapState, mapMutations } from 'vuex'
import mixin from '../../common/mixin/mixins'
import BScroll from 'better-scroll'
import MescrollVue from 'mescroll.js/mescroll.vue'

export default {
  name: 'Department',
  data() {
    return {
      scroll: null,
      operativeList: [],
      operativeActiveList: [0],
      bannerList: [],
      SubjectTCode: '',
      OperativeCode: '',
      OperativeSecondLevelList: [],
      columnList: [],
      ColumnId: '',
      ColumnTCode: '',
      ColumnCode: '',
      ColumnSecondLevelList: [],
      tempColumnSecondLevelList: [],
      sonColumnTCode: '',
      tempXWSonColumnTCode: '',
      ModuleType: 1,
      col: 2,
      list: [],
      PageIndex: 0,
      PageSize: 6,
      mescroll: null, // mescroll实例对象
      mescrollDown:{
        use: false,
        isLock: false
      },
      mescrollUp: { // 上拉加载的配置.
        isBounce: false,
			  callback: this.upCallback, // 上拉回调
				page: {
					num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
					size: 6 //每页数据条数,默认10
				},
        noMoreSize: 0,
				htmlNodata: '<p class="upwarp-nodata">-- END --</p>',
        toTop: {
          warpId : 'toTop',
          src: './static/image/top_comm_icon@2x.png' // 回到顶部按钮的图片路径,支持网络图
        },
        empty: {
          // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才生效;
          warpId: 'dataList', // 父布局的id;
          icon: './static/image/none_comm_png@2x.png', // 图标,支持网络图
          tip: '敬请期待', // 提示
        },
			},
      weeklyCalendarDate: '',
      calendarKey: '',
      showActivityFilteringPicker: false
    }
  },
  mixins: [mixin],
  components: {
    MescrollVue
  },
  computed: {
    ...mapState(['xwTipsShow']),
    code() {
      return this.$route.query.code;
    },
    departmentId() {
      return this.$route.query.id;
    },
    MType() {
      return this.$route.query.ModuleType;
    },
  },
  watch: {
    navBar(newVal) {
      if(this.code && !newVal.some(obj => obj.Code == this.code)) {
        this.$router.replace('/home');
      }
      this.$nextTick(() => {
        this.scroll.refresh();
        let el = document.querySelector(".active_classify");
        this.scroll.scrollToElement(el,0,0)
      })
    },
    // SubjectTCode() {
    //   this.list = [];
    //   this.mescroll.resetUpScroll() // 刷新列表数据
    // },
    ColumnId() {
      this.list = [];
      this.mescroll.resetUpScroll() // 刷新列表数据
    },
    ModuleType(newVal) {
      this.list = [];
      this.mescroll.resetUpScroll() // 刷新列表数据
    }
  },
  beforeRouteEnter(to, from, next) {
    if(to.query.id) {
      next()
    } else {
      next('/invalidPage')
    }
  },
  created() {
    if(this.userInfo && this.userInfo.Id) {
      this.getNavbar();
    }

    this.getOperative();
    this.getBanner();
    this.getColumnList();

    if(this.code) {
      this.SubjectTCode = this.code + '|';
    }

    if(this.MType) {
      this.ModuleType = this.MType;
    }
  },
  mounted() {
    this.initBScroll();
    this.$store.commit('changeNavbarIndex', 0);
  },
  activated(){
    wx.miniProgram.postMessage({
      data: {
        share: {
          title: '科室首页',
          imageUrl: '',
          path: `/pages/oneSurgery/oneSurgery?url=${encodeURIComponent(process.env.VUE_APP_BASE_URL + `/department?id=${this.$route.query.id}&code=${this.$route.query.code}`)}`,
          contentId: ''
        }
      }
    })
    
    this.BuriedPoint(6, '', `${this.code}|`, `/department?id=${this.$route.query.id}code=${this.code}`);
    
    this.mescroll.setBounce(false);
    this.mescroll.scrollTo(this.mescroll.preScrollY, 0);
    this.$store.commit('changeNavbarIndex', 0);
  },
  deactivated() {
    this.mescroll.setBounce(true);
  },
  methods: {
    ...mapMutations(['changeXWTipsShow']),
    // 初始化BScroll
    initBScroll() {
      this.$nextTick(() => {
        this.scroll = new BScroll(this.$refs['wrapper'], {
              startX: 0,
              click: true,
              scrollX: true,
              scrollY: false,
              eventPassthrough: 'vertical'
        })
      })
    },
    // mescroll组件初始化的回调,可获取到mescroll对象
		mescrollInit (mescroll) {
			this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
		},
    // 上拉回调
		upCallback (page) {
      this.getList(page.num, page.size);
		},
    toHome() {
      this.BuriedPoint(1, '首页', '', '/home');
      this.$router.push('/home')
    },
    // 获取亚术式
    async getOperative() {
      let res = await this.$axios.post('/Api/Api/Web/Customer/GetDitWebCode?type=2&pcode=' + this.code)
      this.operativeList = res.Data;
      if (res.Data.length > 0) {
        this.OperativeCode = res.Data[0].code;
        // this.getOperativeSecondLevel(this.OperativeCode);
      }
    },
    // 获取Banner
    getBanner() {
      this.$axios.get('/Api/api/Web/ImgFile/GetImgFileListByCode?Code='+ this.code).then(res => {
        this.bannerList = res.Data;
      })
    },
    // 获取栏目
    async getColumnList() {
      let res = await this.$axios.get('/Api/api/Web/Subject/GetColumnListByCode?Code='+ this.code);
      this.columnList = res.Data;
    },
    // 获取专家用线解读
    async getColumnSecondLevel() {
      let res = await this.$axios.post('/Api/Api/Web/Customer/GetDitWebCode?type=3&pcode=' + this.ColumnCode);
      this.ColumnSecondLevelList = res.Data;
      this.tempColumnSecondLevelList = res.Data;
    },
    // 选择亚术式
    selectOperative(id, TCcode, code, name) {
      const index = this.operativeActiveList.indexOf(parseInt(id));
      if (index !== -1) {
        this.operativeActiveList.splice(index, 1);
      } else {
        this.operativeActiveList.push(parseInt(id));
        this.BuriedPoint(1, name, TCcode, `/department?id=${this.departmentId}&code=${this.code}`);
      }

      // if(TCcode == this.$route.query.code + '|') {
      //   let allIndex = this.operativeActiveList.indexOf(this.$route.query.code + '|');
      //   if (allIndex !== -1) {
      //     this.operativeActiveList.splice(allIndex, 1);
      //   } else {
      //     this.operativeActiveList = [this.$route.query.code + '|'];
      //     this.BuriedPoint(1, name, TCcode, `/department?code=${this.code}`);
      //   }
      // } else {
      //   let allIndex = this.operativeActiveList.indexOf(this.$route.query.code + '|');
      //   if (allIndex !== -1) {
      //     this.operativeActiveList.splice(allIndex, 1);
      //   }

      //   const index = this.operativeActiveList.indexOf(TCcode);
      //   if (index !== -1) {
      //     this.operativeActiveList.splice(index, 1);
      //   } else {
      //     this.operativeActiveList.push(TCcode);
      //     this.BuriedPoint(1, name, TCcode, `/department?code=${this.code}`);
      //   }
      // }

      this.list = [];
      this.mescroll.resetUpScroll() // 刷新列表数据
    },
    // 选择栏目
    selectColumns(id, TCode, code, name) {
      if(this.ColumnId == id) {
        this.ColumnId = ''
      } else {
        this.ColumnId = id;
        this.BuriedPoint(1, name, TCode, `/department?id=${this.departmentId}&code=${this.code}`);
      }

      // if(this.ColumnTCode == TCode && this.ColumnCode == code) {
      //   this.ColumnTCode = '';
      //   this.ColumnCode = '';
      //   this.sonColumnTCode = '';
      //   this.weeklyCalendarDate = '';
      // } else {
      //   this.ColumnTCode = TCode;
      //   this.ColumnCode = code;
      //   this.sonColumnTCode = '';
      //   this.weeklyCalendarDate = '';
      //   this.getColumnSecondLevel();
      //   this.BuriedPoint(1, name, TCode, `/department?code=${this.code}`);
      // }
    },
    // 选择栏目子分类
    selectSonColumn(TCcode, name) {
      if (this.sonColumnTCode == TCcode) {
        this.sonColumnTCode = '';
      } else {
        this.sonColumnTCode = TCcode;
      }
      this.BuriedPoint(1, name, TCcode, `/department?code=${this.code}`);
    },
    // 心外活动筛选
    selectActivityFiltering(index) {
      this.tempColumnSecondLevelList[index].isChecked = !this.tempColumnSecondLevelList[index].isChecked;
      this.$forceUpdate();
    },
    // 加载对应分类下的list
    selectClassify(type) {
      if(this.ModuleType != type) {
        this.ModuleType = type;
      }
    },
    getList(PageIndex, PageSize) {
      this.PageIndex = PageIndex;
      this.PageSize = PageSize;

      setTimeout(() => {
        this.$axios.post('/Api/Api/Web/Article/GetArticleList', {
          // SubjectTCode: this.code + '|',
          SubId: parseInt(this.departmentId),
          // ColumnTCode: this.ColumnTCode,
          SubId2: parseInt(this.ColumnId),
          ModuleType: this.ModuleType,
          // Code: this.ColumnCode,
          Code: '',
          PageIndex: this.PageIndex,
          PageSize: this.PageSize,
          // STCode: this.operativeActiveList.indexOf(this.code + '|') !== -1 ? [] : this.operativeActiveList,
          SId: this.operativeActiveList.indexOf(0) !== -1 ? [] : this.operativeActiveList,
          IsShowLive: true
        }).then(res => {
          let arr = res.Data.List;
          // 如果是第一页需手动置空列表
          if (PageIndex === 1) this.list = []
          // 把请求到的数据添加到列表
          this.list = this.list.concat(arr)
          this.$forceUpdate()
          // 数据渲染成功后,隐藏下拉刷新的状态
          this.$nextTick(() => {
            this.mescroll.endSuccess(arr.length)
          })
        })
      }, 300);
    },
    // 获取直播列表数据
    getLiveList() {
      this.$axios.post('/Api/Api/Web/Article/GetLiveArticleList', {
        time: this.weeklyCalendarDate,
        code: this.code,
        tcode: this.SubjectTCode
      }).then(res => {
        let list = res.Data;
        let liveList = [];
        let previewList = [];
        list.forEach(item => {
          if(item.LiveStatus == 1) {
            liveList.push(item);
          } else if(item.LiveStatus == 2) {
            previewList.push(item);
          }
        });

        if(this.ModuleType == 5) {
          this.list = list;
        } else if(this.ModuleType == 4) {
          if(liveList.length > 0) {
            this.list = liveList;
          } else {
            this.list = previewList;
          }
        }

        this.$nextTick(() => {
          this.mescroll.endSuccess(this.list.length)
        })
      })
    },
    activeDate(date) {
      this.weeklyCalendarDate = date;
      this.mescroll.resetUpScroll(); // 刷新列表数据
    },
    toDepartment(id, code, tcode, name) {
      if(this.departmentId != id) {
        let url = `/department?id=${id}&code=${this.code}`;
        this.BuriedPoint(1, name, tcode, url);
        this.$router.push({
          path: 'department',
          query: {
            id: id,
            code: code
          }
        })
      }
    },
    toContentPage(id, type) {
      if(type == 3) {
        this.$router.push({
          path: 'liveDetails',
          query: {
            id: id
          }
        });
      } else {
        this.$router.push({
          path: 'contentPage',
          query: {
            id: id,
            type: type
          }
        });
      }
    },
    imgclick(info) {
      if(info.LinkType && info.UrlLink) {
        if(info.LinkType == 1) {
          let objExp=new RegExp(/^(f|ht)tps?:\/\//i);
          if(objExp.test(info.UrlLink)) {
            location.href = info.UrlLink;
          } else {
            this.$router.push(info.UrlLink);
          }
        } else if(info.LinkType == 2) {
          wx.miniProgram.navigateTo({url: info.UrlLink})
        } else if(info.LinkType == 3) {
          if (info.UrlLink.indexOf('?') !== -1) {
            info.UrlLink += '&sourceType=3&sourceId=' + info.Id;
          } else {
            info.UrlLink += '?sourceType=3&sourceId=' + info.Id;
          }
          this.$router.push(info.UrlLink);
        }
      }
      this.BuriedPoint(3, info.DepartmentName, info.DepartmentCode, info.UrlLink, info.Id);
    },
    closeTips() {
      this.changeXWTipsShow(false);
    },
    showActivityFiltering() {
      this.showActivityFilteringPicker = true;
      this.tempColumnSecondLevelList = JSON.parse(JSON.stringify(this.ColumnSecondLevelList));
    },
    onActivityFilteringCancel() {
      this.showActivityFilteringPicker = false;
      this.tempColumnSecondLevelList = JSON.parse(JSON.stringify(this.ColumnSecondLevelList));
      this.$forceUpdate();
    },
    onActivityFilteringConfirm() {
      this.showActivityFilteringPicker = false;
      this.ColumnSecondLevelList = JSON.parse(JSON.stringify(this.tempColumnSecondLevelList));
      this.sonColumnTCode = "";
      this.ColumnSecondLevelList.forEach(item => {
        if(item.isChecked) {
          this.sonColumnTCode += item.TCcode + ',';
        }
      });
      this.sonColumnTCode = this.sonColumnTCode.substr(0, this.sonColumnTCode.length - 1);
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  min-height: 100%;
  padding: 16px 0 56px;
  box-sizing: border-box;
  background-color: #F9F9F9;
  .headerBox {
    padding-top: 16px;
    background-color: #EB1701;
  }
  .mescroll {
    position: fixed;
    top: 0;
    bottom: 60px;
    height: auto;
  }
  .top {
    margin-bottom: 10px;
    display: flex;
    padding: 0 12px;
    .menuIcon {
      width: 30px;
      height: 30px;
    }
    .searchBox {
      display: flex;
      align-items: center;
      flex: 1;
      height: 30px;
      line-height: 30px;
      border-radius: 30px;
      background-color: #FFFFFF;
      padding: 0 12px;
      .searchIcon {
        width: 16px;
        height: 16px;
      }
      .searchInput {
        flex: 1;
        margin-left: 5px;
        border: none;
        background-color: transparent;
        color: #999999;
      }
    }
  }
  .classify {
    display: flex;
    color: #FFFFFF;
    height: 31px;
    padding: 0 12px;
    .classify_content {
      display: flex;
      flex: 1;
      font-size: 14px;
      overflow: hidden;
      .classify_wrapper {
        white-space: nowrap;
        span {
          position: relative;
          margin-right: 20px;
        }
        .active_classify {
          font-size: 18px;
          font-weight: bold;
        }
        .active_classify::after {
          content: "";
          width: 22px;
          height: 3px;
          border-radius: 3px;
          background-color: #FFFFFF;
          position: absolute;
          top: 24px;
          left: 50%;
          transform: translateX(-11px);
        }
      }
    }
    .more {
      font-size: 12px;
      margin-left: 10px;
      a {
        display: flex;
        align-items: center;
        color: #FFFFFF;
        margin-top: 6px;
      }
      .addIcon {
        width: 18px;
        height: 18px;
        margin-right: 4px;
      }
      span {
        opacity: 0.8;
      }
    }
  }
  .content {
    min-height: 100%;
    margin-top: 1px;
    padding: 5px 12px 0;
    background-color: #F9F9F9;
  }
  .content:before{
    content: '';
    display: table;
  }
  .department_classify {
    display: flex;
    flex-wrap: wrap;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 23%;
      height: 28px;
      line-height: 28px;
      border-radius: 28px;
      background-color: #FFFFFF;
      border: 1px solid #CA001B;
      font-size: 11px;
      color: #CA001B;
      box-sizing: border-box;
      margin-top: 10px;
      padding: 0 10px;
    }
    span:not(:nth-child(4n)) {
      margin-right: calc(8% / 3);
    }
    .department_classify_active {
      color: #FFFFFF;
      background-image: url('../../assets/images/btn_bg1.png');
      background-size: 100% 100%;
    }
  }
  .banner {
    margin: 15px 0;
    background-color: #FFFFFF;
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    overflow: hidden;
    .bannerImg {
      width: 100%;
      display: block;
    }
  }
  .sonOperative {
    span {
      font-size: 12px;
      color: #666666;
      margin-right: 20px;
    }
    .activeSonOperative {
      font-size: 15px;
      color: #CA001B;
      font-weight: bold;
    }
  }
  .section {
    display: flex;
    border-radius: 10px;
    background-color: #FFFFFF;
    margin: 10px 0 12px;
    padding: 12px 0;
    .section_box {
      flex: 1;
      text-align: center;
    }
    .section_item {
      img {
        display: block;
        margin: 0 auto 5px;
        width: 40px;
        height: 40px;
      }
      span {
        font-size: 12px;
        color: #564C47;
      }
      .section_item_active {
        color: #CA001B !important;
        font-weight: bold;
      }
    }
  }
  .listContainer {
    background-color: #FFFFFF;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    padding: 5px;
    border-radius: 8px;
    box-sizing: border-box;
    margin-top: 15px;
  }
  .classify_title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    margin-top: 5px;
    font-size: 15px;
    color: #333333;
    .classify_title_left {
      display: flex;
      align-items: flex-end;
      .classify_item {
        display: flex;
        align-items: center;
        width: 80px;
        height: 22px;
        border-radius: 22px;
        margin-right: 10px;
        padding: 1px;
        box-sizing: border-box;
        background: linear-gradient(135deg, #EB1700 0%, #C33BBB 50%, #8C3BBB 100%);
        div {
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex: 1;
        }
        .classifyIcon {
          img {
            display: block;
            margin-left: 2px;
          }
          .classifyIcon1 {
            width: 16px;
          }
          .classifyIcon2 {
            width: 13px;
          }
        }
        .classifyTitle {
          border-radius: 0 22px 22px 0;
          background-color: #FFFFFF;
          font-size: 12px;
          color: #CA001A;
        }
      }
      .classify_title_active {
        width: 90px;
        height: 25px;
        border-radius: 25px;
        padding: 0;
        .classifyIcon {
          img {
            display: block;
            margin-left: 2px;
          }
          .classifyIcon1 {
            width: 19px;
          }
          .classifyIcon2 {
            width: 15px;
          }
        }
        .classifyTitle {
          border-radius: 0 22px 22px 0;
          background-color: transparent;
          font-size: 14px;
          color: #FFFFFF;
          border-left: 1px solid #FFFFFF;
        }
      }
    }
    .classify_title_right {
      position: relative;
      display: flex;
      .classify_title_right_item {
        display: flex;
        align-items: center;
        img {
          width: 15px;
          height: 15px;
          margin-left: 5px;
        }
      }
      .screenBtn {
        margin-top: 4px;
        font-size: 14px;
        color: #CA001B;
        img {
          width: 12px;
          height: 12px;
          vertical-align: middle;
          margin-left: 3px;
        }
      }
      .screenTips {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        right: -2px;
        bottom: 35px;
        z-index: 99;
        width: 256px;
        height: 30px;
        line-height: 30px;
        border-radius: 10px;
        padding: 0 15px;
        box-sizing: border-box;
        background: rgba(0, 0, 0, 0.75);
        font-size: 12px;
        color: #FFFFFF;
        img {
          width: 10px;
          height: 10px;
        }
      }
      .screenTips:before{
        content: "";
        width: 0px;
        height: 0px;
        border-top: 8px solid rgba(0, 0, 0, 0.75);
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        position: absolute;
        top: 30px;
        right: 9px;
      }
    }
  }
  .list {
    width: 100%;
    background-color: #FFFFFF;
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 10px;
    .item_img {
      position: relative;
      .item_cover {
        display: block;
        width: 100%;
      }
      .playIcon {
        position: absolute;
        right: 3px;
        bottom: 3px;
        width: 20px;
        height: 20px;
      }
    }
    .item_content {
      padding: 5px 8px;
      background-color: #F9F8F7;
      color: #564C47;
      .item_title {
        font-size: 14px;
      }
      .doctor_info {
        font-size: 11px;
        margin-top: 5px;
        span {
          color: #999999;
        }
      }
      .item_flexbox {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .item_time {
        font-size: 12px;
        line-height: 24px;
      }
      .item_label {
        display: flex;
        flex-wrap: wrap;
        span {
          display: inline-block;
          height: 20px;
          line-height: 20px;
          border-radius: 2px;
          padding: 0 6px;
          margin-right: 6px;
          margin-bottom: 5px;
          background-color: rgba(255, 73, 98, 0.15);
          font-size: 11px;
          color: #CA001B;
        }
      }
      .item_nums {
        display: flex;
        justify-content: flex-end;
        .nums {
          display: flex;
          align-items: center;
          img {
            width: 12px;
            margin: 0 2px 0 6px;
          }
          span {
            font-size: 11px;
          }
        }
      }
    }
  }
  .liveItem {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    width: 100%;
    height: 84px;
    border: 1px solid #DDDDDD;
    border-radius: 10px;
    padding: 4px 12px;
    box-sizing: border-box;
    overflow: hidden;
    margin-bottom: 10px;
    background-color: #FFFFFF;
    .liveStatu {
      display: flex;
      align-items: center;
      position: absolute;
      top: 0;
      right: 0;
      font-size: 11px;
      color: #CA001B;
      padding: 2px 8px;
      background-color: #F9E5E8;
      border-radius: 0 10px 0 10px;
      .icon_live {
        width: 12px;
        height: 12px;
        margin-left: 6px;
        opacity: 1 !important;
      }
    }
    .date {
      font-size: 12px;
      color: #999999;
    }
    .liveTitle {
      font-size: 15px;
      color: #333333;
      font-weight: bold;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
    }
    .WatchCount {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #999999;
      img {
        width: 12px;
        margin-right: 2px;
      }
    }
  }
}

.picker_content {
    padding: 12px 6px;
    .pickerBox {
      display: flex;
      flex-wrap: wrap;
    }
    .picker_block {
      display: flex;
      justify-content: center;
      align-items: center;
      width: calc(calc(100% / 3) - 12px);
      height: 36px;
      text-align: center;
      border: 1px solid rgba(153, 153, 153, 0.5);
      box-sizing: border-box;
      margin: 6px;
      border-radius: 4px;
      color: #333333;
      font-size: 14px;
    }
    .activeBg {
      border: none;
      color: #C70C3C;
      background-image: url('../../assets/images/select_system_btn@2x.png');
      background-repeat: no-repeat;
      background-size: cover;
    }
  }

.screenItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 132px;
  height: 32px;
  // line-height: 32px;
  font-size: 13px;
  color: #333333;
  padding: 0 12px;
  img {
    width: 12px;
    height: 12px;
  }
}
.liveScreenActive {
  color: #CA001B;
}
.iconLink {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 120px;
  right: 8px;
  .iconBox {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 3px;
  }
  img {
    width: 40px;
    height: 40px;
  }
  span {
    font-size: 10px;
    color: #CA001B;
  }
}

/deep/ .van-swipe__indicators {
  top: 90%;
}
</style>